import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      title: t('service_1_title'),
      description: t('service_1_desc'),
      image: 'https://public.readdy.ai/ai/img_res/337d4e4d74fea7948f0fc18e0dc85a28.jpg',
      icon: 'ri-flashlight-line'
    },
    {
      title: t('service_2_title'),
      description: t('service_2_desc'),
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/8033c8661b4769c6e7b102cff77d32a4.jpeg',
      icon: 'ri-building-line'
    },
    {
      title: t('service_3_title'),
      description: t('service_3_desc'),
      image: 'https://readdy.ai/api/search-image?query=Industrial%20equipment%20repair%20and%20maintenance%20welding%20service%2C%20professional%20technician%20fixing%20metal%20machinery%2C%20preventive%20maintenance%20on%20industrial%20metal%20structures%2C%20skilled%20repair%20work%20on%20heavy%20duty%20equipment%20in%20factory%20setting&width=600&height=400&seq=service003&orientation=landscape',
      icon: 'ri-tools-line'
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-light text-white mb-4">
            {t('services_title')}
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            {t('services_subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-slate-800 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 w-full overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-800 to-transparent"></div>
                <div className="absolute top-4 right-4 w-14 h-14 bg-orange-600 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <button className="text-orange-500 font-semibold hover:text-orange-400 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
                    {t('service_btn_more')}
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  <span className="text-sm text-gray-400 whitespace-nowrap">{t('service_available')}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
